/* eslint key-spacing: 'off', comma-spacing: 'off', brace-style: 'off' */
import current from '@/scripts/current';
import commonTestHelper from '@/scripts/commonTestHelper';
import variableDataAccess from '@/scripts/variableDataAccess';
import testHelper from '@/scripts/logisticRegression/testHelper';

function setTestUpTo() {
    // return 'years';
    // return 'locations';
    // return 'dependent';
    //return 'independent';
    return null;
}

export default {
    variableList: null,
    getVariableList: function () {
        if (!testHelper.variableList)
            testHelper.variableList = variableDataAccess.getPairedVariables2(['isDependent', 'isIndependent']);
        return testHelper.variableList;
    },
    setTest: function (stepIndex, years, locations, variables, levels, options) {
        setTest(stepIndex, years, locations, variables, levels, options);
    },
    setTestValues: function (currentStep, $route) {
        var node = process.env.NODE_ENV;

        if (process.env.NODE_ENV && process.env.NODE_ENV !== 'development')
            return;
        commonTestHelper.setIsInAutomatedTesting($route);
        var stepIndex = current.navigation.stepIndex[currentStep];
        if (window.inAutomatedTesting)
            return commonTestHelper.setAutomatedTestValues(stepIndex, testHelper.getVariableList());
        //testVi22
        //missingData3
        //
        //let test = 'errorOnSetReferencePage';
        let test = 'none';
        if (test === 'none')
            return;
        else if (test === 'doesntMatch')
            setTest(stepIndex, [2007], [1, 2, 3], ['R_FLUSHOT365', 'R_AIDSTST', 'R_BMICAT']);
        // These are not valid tests because you can't  compare just year or location if missing data
        // else if (test === 'missingData2x')
        //   setTest(stepIndex, [2014, 2016], [1], ['R_EXTETH2', 'year', 'RN_HTM4'], null, { compareYears: true }); //Tested for 3.1
        // else if (test === 'missingData2')
    //   setTest(stepIndex, [2014, 2016], [78], ['R_EXTETH2', 'year', 'RN_HTM4'], null, { compareYears: true }); //Tested for 3.1
        // else if (test === 'missingData2b')
        //   setTest(stepIndex, [2014], [1, 78], ['R_EXTETH2', 'location', 'RN_HTM4'], null, { compareLocations: true }); //Tested for 3.1
        else if (test === 'missingData3')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_EXTETH2', 'year', 'location', 'RN_HTM4'], null, { compareYears: true, compareLocations: true }); //Tested for 3.1
        else if (test === 'missingData4')
            setTest(stepIndex, [2014], [1, 78], ['R_EXTETH2', 'location', 'RN_HTM4'], null, { compareLocations: true }); //Tested for 3.1
        else if (test === 'errorOnSetReferencePage')
            setTest(stepIndex, [2015, 2016], [4, 5], ['R_PNEUMO2', 'year', 'location', 'R_AGEG5YR'], null, { compareYears: true, compareLocations: true });
        else if (test === 'error006')
            setTest(stepIndex, [2008], [1, 2, 3], ['R_RFDRWM', 'location']);
        else if (test === 'testVi11')
            setTest(stepIndex, [2014, 2015, 2016, 2017, 2018], [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14 , 15, 16, 17, 78], ['R_RFBLDS3', 'RN_DRNKDRI2']);
        else if (test === 'testVi12')
            setTest(stepIndex, [2014, 2016], [78], ['R_RFBLDS3', 'year', 'RN_DRNKDRI2']);
        else if (test === 'testVi13')
            setTest(stepIndex, [2014, 2016], [78], ['R_RFBLDS3', 'RN_DRNKDRI2', 'year']);
        else if (test === 'testVi131')
            setTest(stepIndex, [2014], [1, 2, 78], ['R_RFBLDS3', 'RN_DRNKDRI2', 'location']);
        else if (test === 'testVi14')
            setTest(stepIndex, [2016], [78], ['R_RFBLDS3', 'RN_DRNKDRI2']);
        else if (test === 'testVi21')
            setTest(stepIndex, [2014, 2016], [10, 78], ['R_RFBLDS3', 'year', 'location', 'RN_DRNKDRI2', 'R_DRNKDRV'], null, { compareYears: true, compareLocations: true });
        else if (test === 'testVi22')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_RFBLDS3', 'year', 'RN_DRNKDRI2']);
        else if (test === 'testVi23')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_RFBLDS3', 'RN_DRNKDRI2', 'year']);
        else if (test === 'testVi32')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_RFBLDS3', 'location', 'RN_DRNKDRI2']);
        else if (test === 'testVi33')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_RFBLDS3', 'RN_DRNKDRI2', 'location']);
        else if (test === 'matches')
            setTest(stepIndex, [2007], [1, 2, 3], ['R_FLU3SHOT65', 'R_EDUCAG', 'R_BMICAT', 'R_EMPLOY']);
        else if (test === 'matches1')
            setTest(stepIndex, [2007], [1, 2, 3], ['R_FLU3SHOT65', 'R_EDUCAG']);
        else if (test === 'matches2')
            setTest(stepIndex, [2007], [1, 2, 3], ['R_FLU3SHOT65', 'R_BMICAT']);
        else if (test === 'error003')
            setTest(stepIndex, [2015, 2016], [4], ['R_FLU6SHOT65', 'R_HCVU651']);
        else if (test === 'error004')
            setTest(stepIndex, [2015], [6], ['R_FLU6SHOT65', 'R_PNEUMOC']);
        else if (test === 'error005')
            setTest(stepIndex, [2008], [0], ['R_AIDSTST', 'R_FLU3SHOT65']);
        else if (test === 'throughDependentWithYearAndLocation') {
            commonTestHelper.setYearAsCompare(stepIndex, [2012, 2014]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setDependentAs(stepIndex, 'R_AGE4CAT', 2012);
        }
        else if (test === 'throughDependentSelected') {
            commonTestHelper.setYearAs(stepIndex, 2005);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setDependentAs(stepIndex, 'R_FMENTHLTH', 2005);
        }

        else if (test === 'continuousIndependent') {
            commonTestHelper.setYearAs(stepIndex, 2005);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setDependentAs(stepIndex, 'R_FMENTHLTH', 2005);
            setIndependentAs(stepIndex, ['RN_DRNKMO', 'R_PERSDOC2C'], 2005);
            current.selectionModel.reference = { dependent: 1, independent: [1, 1] };
        }
        else if (test === 'combineYears2') {
            commonTestHelper.setYearAsCombine(stepIndex, [2006, 2007, 2008, 2009, 2010]);
            commonTestHelper.setLocationAsCombineByIndex(stepIndex, 1, 3);
            setDependentAs(stepIndex, 'R_PNEUVAC', 2006);
            setIndependentAs(stepIndex, ['R_RFSEAT3'], 2006);
            current.selectionModel.reference = { dependent: 2, independent: [2] };
        }
        else if (test === 'combineYears3') {
            commonTestHelper.setYearAsCombine(stepIndex, [2012, 2013, 2014]);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);  //Alabama, Arkanasas, Arizona
            setDependentAs(stepIndex, 'R_HLTHPLN1', 2012);
            setIndependentAs(stepIndex, ['RN_BMI5', 'R_BMI5CAT', 'R_EDUCAG', 'R_EDUCA', 'R_RACEGRW'], 2012);
            current.selectionModel.reference = { dependent: 1, independent: [1, 1, 1, 1, 1] };
        }
        else if (test === 'compareYears3') {
            commonTestHelper.setYearAsCompare(stepIndex, [2012, 2014]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setDependentAs(stepIndex, 'R_AGE4CAT', 2012);
            setIndependentAs(stepIndex, ['location', 'year'], 2012);
            current.selectionModel.reference = { dependent: 2, independent: [2, 2012] };
        }
        else if (test === 'error001') {
            commonTestHelper.setYearAs(stepIndex, 2006);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setDependentAs(stepIndex, 'R_PNEUMOC', 2006);
            setIndependentAs(stepIndex, ['R_AIDSTST'], 2006);
            current.selectionModel.reference = { dependent: 1, independent: [1] };
        }
        else if (test === 'test321') {
            commonTestHelper.setYearAsCompare(stepIndex, [2012, 2014]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setDependentAs(stepIndex, 'year', 2014);
            setIndependentAs(stepIndex, ['R_EDUCA', 'R_AGE4CAT', 'location'], 2014);
            current.selectionModel.reference = { dependent: 1, independent: [4, 2, 2] };
            //this.setIndependentAsVariable(stepIndex);
        }
        else if (test === 'compareYearAndLocations') {
            commonTestHelper.setYearAsCompare(stepIndex, [2012, 2014]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setDependentAs(stepIndex, 'R_EDUCA', 2014);
            setIndependentAs(stepIndex, ['year', 'R_AGE4CAT', 'location'], 2014);
            current.selectionModel.reference = { dependent: 1, independent: [2, 2, 2] };
            //this.setIndependentAsVariable(stepIndex);
        }
        else if (test === 'compareLocations') {
            commonTestHelper.setYearAs(stepIndex, 2014);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setDependentAs(stepIndex, 'R_RFBING5', 2014);
            setIndependentAs(stepIndex, ['R_EDUCA', 'R_AGE4CAT', 'location'], 2014);
            current.selectionModel.reference = { dependent: 1, independent: [4, 2, 2] };
        }
        else if (test === 'compareYears') {
            commonTestHelper.setYearAsCompare(stepIndex, [2014, 2015, 2016]);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setDependentAs(stepIndex, 'R_RFBING5', 2014);
            setIndependentAs(stepIndex, ['R_EDUCA', 'R_AGE4CAT', 'year'], 2014);
            current.selectionModel.reference = { dependent: 1, independent: [3, 2, 2] };
        }
        else if (test === 'smallColsAndRows') {
            commonTestHelper.setYearAsCompare(stepIndex, [2014, 2015, 2016]);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setDependentAs(stepIndex, 'R_RFBING5', 2014);
            setIndependentAs(stepIndex, ['R_EDUCA', 'R_AGE4CAT', 'year'], 2014);
            current.selectionModel.reference = { dependent: 1, independent: [2, 2, 2] };
        }
        else if (test === 'yearAlreadySelectedButNotLocation') {
            commonTestHelper.setYearAsCompare(stepIndex, [2013, 2014, 2015]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setDependentAs(stepIndex, 'year', 2013);
            //this.setIndependentAsVariable(stepIndex);
        }
        else if (test === 'bothYearAndLocationSelected') {
            commonTestHelper.setYearAsCompare(stepIndex, [2013, 2014, 2015]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
        }
        else if (test === 'justCompareYears') {
            commonTestHelper.setYearAsCompare(stepIndex, [2013, 2014, 2015]);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setDependentAs(stepIndex, 'year', 2013);
            this.setIndependentAsVariable(stepIndex, ['R_RFBLDS2', 'R_RFPAP32'], 2014);
        }
        else if (test === 'single') {
            commonTestHelper.setYearAs(stepIndex, 2012);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            this.setIndependentAsVariable(stepIndex, ['R_RFBLDS2', 'R_RFPAP32'], 2014);
            current.modelHelper.setDefaultStatistics();
        }
        console.log('Running test: ', test, current.selectionModel)
    }
}

function setTest(stepIndex, years, locations, variables, levels, options) {
    options = options || {};
    let compareYears = options && options.compareYears;
    let compareLocations = options && options.compareLocations;

    commonTestHelper.smartSetYears(stepIndex, years, compareYears);
    if (options.inAutomatedTesting) {
        console.log('inAutomatedTesting', variables, levels)
        variables = variables || [];
        levels = levels || [];
        for (let i = 0; i < variables.length; ++i) {
            var variableNumber = i + 1; //1
            if (levels.length < variableNumber)
                levels.push(1);
        }
        console.log('inAutomatedTesting', variables, levels)
    } else {
        if (setTestUpTo() === 'years')
            return;

        commonTestHelper.setLocations(stepIndex, locations, years, compareLocations)
        if (setTestUpTo() === 'locations')
            return;

        setDependent(stepIndex, variables[0], years);
        if (setTestUpTo() === 'dependent')
            return;

        setIndependent(stepIndex, variables.slice(1), years);
        if (setTestUpTo() === 'independent')
            return;
    }

    var selectedLevels = levels ? levels.slice() : [];
    //Default all levels to 1
    for (let i = 0; i < variables.length; ++i) {
        if (selectedLevels.length < (i + 1))
            selectedLevels.push(1);
    }
    current.selectionModel.reference = { dependent: selectedLevels[0], independent: selectedLevels.slice(1) };
    console.log('current.selectionModel.reference', current.selectionModel.reference);
}

function setDependent(stepIndex, variable, years) {
    if (stepIndex >= current.navigation.stepIndex.selectDependentVariable)
        current.selectionModel.v.dependent =
            commonTestHelper.createVariableSelection(variable, years[0]);
    console.log('current.selectionModel.v.dependent', current.selectionModel.v.dependent);
}

function setIndependent(stepIndex, variables, years) {
    //console.log('setIndependent', variables, years)
    if (stepIndex >= current.navigation.stepIndex.selectIndependentVariables)
        return current.selectionModel.v.independent =
            variables.map(v => commonTestHelper.createVariableSelection(v, years[0]));
}
